import { createAsyncThunk } from '@reduxjs/toolkit';
import ProviderManager from '../../../provider/providerManager';
import { showAppLoader, hideAppLoader  } from '../../Shared/Loader/LoaderSlice';
import { goToPage , setSubscriber, setRouter} from './SpeedTestAndDisconnectionsWizardBlockSlice';

export const onSelectedSubscriber = createAsyncThunk('speedTestAndDisconnectionsWizardBlock/onSelectedSubscriber', async (data, thunkAPI) => {
    try {
        const state = thunkAPI.getState().speedTestAndDisconnectionsWizardBlock;
        const subscriber = data;
        if (!subscriber.isJetService || subscriber.equipments?.some(x => ["NATAVT", "39081NB"].includes(x.productId?.toUpperCase()))) {
            thunkAPI.dispatch(goToPage({ page: 'RedirectManualInitializationPage' }));
            return;
        }else{
            const routers = state.epiBlockData.routerList;
            const defaultRouter = routers?.find(x => x.defaultRouter.value);
            const matchingRouters = routers?.filter(router => subscriber.equipments.some(equipment => equipment.productId === router.id.value));
            if(matchingRouters?.length > 0){
                thunkAPI.dispatch(setRouter(matchingRouters[0]));
            }else if(defaultRouter){
                thunkAPI.dispatch(setRouter(defaultRouter));
            }
        }
        thunkAPI.dispatch(setSubscriber(subscriber));
        thunkAPI.dispatch(checkDeviceConnection());
        return null;
    } catch (error) {
        console.error(error);
    } finally {
    }
});

export const checkDeviceConnection = createAsyncThunk('speedTestAndDisconnectionsWizardBlock/checkDeviceConnection', async (data, thunkAPI) => {
    try {
        thunkAPI.dispatch(showAppLoader());
        const state = thunkAPI.getState().speedTestAndDisconnectionsWizardBlock;
        const request = {
            ban: state.selectedSubscriber?.ban
        }

        const response = await ProviderManager.getProviderData('checkDeviceConnection', request);

        if(response.Body.checkConnection?.isSuccess){
            thunkAPI.dispatch(goToPage({ page: 'AutomaticRouterInitializationPage' }));
        }
        else{
            thunkAPI.dispatch(goToPage({ page: 'RedirectManualInitializationPage' }));
        }

        return response.Body;
    } catch (error) {
        console.error(error);
    } finally {
        thunkAPI.dispatch(hideAppLoader());
    }
});

export const restartDevice = createAsyncThunk('speedTestAndDisconnectionsWizardBlock/restartDevice', async (data, thunkAPI) => {
    try {
        const state = thunkAPI.getState().speedTestAndDisconnectionsWizardBlock;
        const request = {
            ban: state.selectedSubscriber?.ban
        }
        const response = await ProviderManager.getProviderData('restartDevice', request);

        return response.Body;
    } catch (error) {
        console.error(error);
    } finally {
    }
});

